module.exports = __webpack_public_path__ + "src/assets/img/smartheater.1d891ead.jpg";